module.exports = __webpack_public_path__ + "img/multiMode.e0b4135c.png";